import { networkAction } from "helpers/network/networkAction";

import { UPLOAD } from "constants/uploads";

import * as Api from "api";

export const upload = (file) => async (dispatch) =>
  networkAction(dispatch, UPLOAD, Api.upload, [file]);
